export const CHECKOUT_URL = 'https://pilates-listo.impultienda.ar/checkout'

export const pricing = {
  price: '$19.990',
  currencyNote: 'Pago único',
  /** $98.000 → $19.990 ≈ 80% de descuento. */
  fullValue: '$98.000',
  discountLabel: '80% OFF',
  bonusesValue: '$30.000',
  bonusUnitValue: '$10.000',
  lineItems: [
    { label: '6 tomos digitales completos', price: '$68.000' },
    { label: '3 bonos exclusivos', price: '$30.000' },
  ],
}
